import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "../styles/Pagination.css";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    const getPageNumbers = () => {
        const pages = [];
        if (totalPages <= 7) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            if (currentPage <= 4) {
                pages.push(1, 2, 3, 4, "...", totalPages);
            } else if (currentPage >= totalPages - 3) {
                pages.push(1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            } else {
                pages.push(1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages);
            }
        }
        return pages;
    };

    return (
        <div className="pagination-container">
    {/* Left Arrow */}
    <button 
        className="arrow-btn" 
        onClick={() => onPageChange(currentPage - 1)} 
        disabled={currentPage === 1}
    >
        <FaArrowLeft />
    </button>

    <ul className="pagination">
        {getPageNumbers().map((page, index) => (
            <li
                key={index}
                className={`pagination-item ${page === currentPage ? "active" : ""}`}
                onClick={() => typeof page === "number" && onPageChange(page)}
            >
                {page}
            </li>
        ))}
    </ul>

    {/* Right Arrow */}
    <button 
        className="arrow-btn" 
        onClick={() => onPageChange(currentPage + 1)} 
        disabled={currentPage === totalPages}
    >
        <FaArrowRight />
    </button>
</div>

    );
};

export default Pagination;
